export enum EnviarPara {
  TODOS = 'Todos',
  PAIS = 'Pais',
  PROFESSORES = 'Professores',
  COORDENADORES = 'Coordenadores',
  DIRETORIA = 'Diretoria',
}

export interface AgendaRequest {
  enviarPara: EnviarPara;
  data: string;
  dataLembrete: string;
  color: string;
  categoria: string;
  horaInicio: string;
  horaFim: string;
  diaInteiro: boolean;
  assunto: string;
  descricao: string;
  escola: number;
  idsTurmas: any;
  enviarTodasTurmas: boolean;
  createdAt: any;
  arquivo: any
}
export interface Agenda extends AgendaRequest {
  id: number;
  documentId: string;
}
